
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunityWelcome } from "../../../../store/reducers/getCommnunitySlice";
import { useNavigate } from 'react-router-dom';
import Spinner from "react-bootstrap/Spinner";

const PlayingGames = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { data, loading, error } = useSelector((state) => state?.fetchCommunitySection);

    useEffect(() => {
        dispatch(fetchCommunityWelcome());
    }, [dispatch]);

    // const handleClick = (id) => {
    //     const gameRules = `/games-rules/${id}`;
    //     navigate(gameRules); // Navigate to the URL in the same window
    // };


//the Shopify link 
    const handleClick = () => {
        window.open('http://shop.lfcoin.io/', '_blank');
    }


    const communityData = data[0];

    // Show spinner while loading
    if (loading) {
        return (
            <div className="spinner-container">
                <Spinner animation="border" variant="dark" size="xl" />
            </div>
        );
    }

    if (!communityData || !communityData.heading || !communityData.description) {
        return null;
    }

    return (
        <div className="container Top-storycontainer-section">
            <div className="how-to-play-section mt-5">
                <div className="content-how-to-play">
                    <span>{communityData?.heading}</span>
                    <h3>{communityData?.title}</h3>
                    <p>{communityData?.description}</p>
                    {/* <button
                        // onClick={() => handleClick(communityData._id)}
                        onClick={handleClick}
                        >
                        Shop Now
                    </button> */}

                    <button
    onClick={handleClick} className="shop-now-btn"
    style={{
        borderRadius: '25px', // Adjust the value for more or less rounding
        padding: '10px 20px',
        backgroundColor: '#e8bb23', // Button color
        color: '#4a1d82', // Text color
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color -0.9s ease', // Smooth transition for hover effect
        fontWeight: "bold", /* Make the text bold */   
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#FBC901')} // Darker shade on hover
    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#e8bb23')} // Original color when not hovered
>
    Shop Now
</button>
                </div>
                <img
                    src={`${process.env.REACT_APP_API_ENDPOINT_URL}/${communityData.image}`}
                    className="how-to-play-img"
                    alt="Community Image"
                />
            </div>
        </div>
    );
};

export default PlayingGames;